export default {
    computed: {
        valid() {
            return !Object.values(this.form.fields).some(({valid}) => valid === false)
        }
    }
}